// Carousel.jsx (currently named "index.jsx" in your snippet)
import React, { useEffect, useRef, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "./carousel.css";

import PageOne from "../pageOne";
import PageTwo from "../pageTwo";
import PageThree from "../pageThree";
import PageFour from "../pageFour";
import PageFive from "../pageFive";
import PageSix from "../pageSix";

function Carousel({ slideIndex, setSlideIndex }) {
  const splideRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setSlideIndex(currentIndex);
  }, [currentIndex, setSlideIndex]);

  useEffect(() => {
    if (splideRef.current) {
      splideRef.current.go(slideIndex);
    }
  }, [slideIndex]);

  // 1) Listen for "toggleSplideDrag" event
  useEffect(() => {
    function handleToggleSplideDrag(e) {
      // e.detail.disabled => true or false
      const { disabled } = e.detail;
      console.log(
        "[Carousel] Received toggleSplideDrag => disabled =",
        disabled
      );

      const splideInstance = splideRef.current?.splide;
      if (splideInstance) {
        // 2) Update Splide's drag option
        splideInstance.options = {
          ...splideInstance.options,
          drag: !disabled, // if disabled=true => drag=false
        };
        // 3) Refresh Splide to apply new options
        splideInstance.refresh();
      }
    }

    // 4) Attach the listener on mount
    window.addEventListener("toggleSplideDrag", handleToggleSplideDrag);

    // 5) Cleanup on unmount
    return () => {
      window.removeEventListener("toggleSplideDrag", handleToggleSplideDrag);
    };
  }, []);

  return (
    <div className="slide_container">
      <Splide
        ref={splideRef}
        options={{
          type: "loop",
          perPage: 1,
          autoHeight: true,
          height: "auto",
          width: "100%",
          // initial drag setting (true or false) can be whatever
          // Splide doesn't allow drag if only 1 slide, but let's keep it:
          drag: true,
        }}
        onMove={(splide, newIndex) => setCurrentIndex(newIndex)}
      >
        <SplideSlide>
          <PageOne />
        </SplideSlide>
        <SplideSlide>
          <PageTwo isActive={currentIndex === 1} />
        </SplideSlide>
        <SplideSlide>
          <PageThree isActive={currentIndex === 2} />
        </SplideSlide>
        <SplideSlide>
          <PageFour />
        </SplideSlide>
        <SplideSlide>
          <PageFive isActive={currentIndex === 4} />
        </SplideSlide>
        <SplideSlide>
          <PageSix />
        </SplideSlide>
      </Splide>
    </div>
  );
}

export default Carousel;
